import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';


const SeoHyeRim = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "홍래 ♥ 혜림 결혼식에 초대 합니다";
    const openDesc = "5월 10일 오전11시 W스퀘어 웨딩";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/137/thumb.jpg";

    const lng = 129.051025653009;
    const lat = 35.1644055707399;

    const placeTelNum = "051-711-0177";

    const forSubway = "· 1호선, 2호선 서면역 9번출구 [셔틀운행]\n· 2호선 부암역 4번출구 [도보 10분 및 셔틀이용]";
    const forCar = "부산 부산진구 신천대로 252 3층\n주차 : 건물 지하 2층 ~ 지하4층 이용가능\n\n[경남, 전라권] \n 남해고속도로 > 냉정분기점 > 동서고가 진양램프 \n> 진양사거리 좌회전\n\n [수도, 충청, 강원권] \n 경부고속도로 > 대구, 부산 고속도로 > 백양터널 \n> 진양사거리 좌회전"
    const forBus = "· 진구청앞 하차 : 54, 66, 81, 83-1, 133, 63 \n[이마트 주차장 입구쪽으로 도보 5분]\n· 진양교차로 하차 : 17, 23, 44, 129-1, 138-1, 141, \n160, 167, 169-1 [부암로타리 방면 도보 5분]";
    const forShuttleBus = "1시간 3회운영 (20분 간격)\n\nW스퀘어 웨딩[셔틀버스 정류장] 정시 / 20분 / 40분\n↓\n서면역 9번출구 [영광도서 맞은편 마을버스 정류장] \n10분 / 30분 / 50분\n↓\n부암역 4번출구 [20m앞 공중전화기] 15분 / 35분 / 55분"

    // const parents = [
    //     {groom : "명남식 · 故안인순의 아들"},
    //     {bride : "이금하 · 구은숙의 딸"}
    // ]

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        // spring 핑크B
        concept: "SPRING",
        titleColor: "#ff8faf",
        pointColor: "#ff8faf",
        btnBgColor: "#ffcfe1",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }


    const infoTitle = "홍래 ♥ 혜림 결혼식에 초대합니다";

    const msg1 = "봄 햇살이 함께 했던 지난날,\n여러 해의 봄날처럼\n앞으로도 햇살 같은 봄날을 함께 하려 합니다.";
    const msg2 = "부디 귀한 시간 내주시어 저희의 봄날에 함께\n축복해주시면 감사하겠습니다."
    const msg3 = "\n저희의 시작을 따뜻한 마음으로 축북해주신다면\n그 힘으로 평생을 걸어가겠습니다."

    const groomAccountList = [
        {
            role: "신랑",
            name: "조홍래",
            bank: "신한은행",
            accountNumber : "110-501-549265",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FSx61pBHi"
        }
        // ,{
        //     role: "신랑 부",
        //     name: "000",
        //     bank: "국민은행",
        //     accountNumber : "657802-01-049965",
        //     isKakao :  false
        // }
        ,{
            role: "신랑 모",
            name: "김임숙",
            bank: "부산은행",
            accountNumber : "310-12-005993-3",
            isKakao :false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "서혜림",
            bank: "신한은행",
            accountNumber : "110-546-793938",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8c5MC5A"
        }
        ,{
            role: "신부 부",
            name: "서광석",
            bank: "농협은행",
            accountNumber : "352-0579-4527-03",
            isKakao :false
        }
        ,{
            role: "신부 모",
            name: "송선희",
            bank: "경남은행",
            accountNumber : "558-21-0346506",
            isKakao : false
        }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "강우민",
            call: "010-7560-4109"
        }
        ,{
            role: "신랑 부",
            name: "명남식",
            call: "010-4028-0087"
        }
        ,{
            role: "신랑 모",
            name: "김영숙",
            call: "010-9118-4109"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "박지선",
            call: "010-9024-6645"
        }
        ,{
            role: "신부 부",
            name: "000",
            call: "010-5065-6858"
        },
        {
            role: "신부 모",
            name: "000",
            call: "010-3393-0658"
        }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 어땠어?",
            groomAnswer: "공주두둥장",
            brideAnswer: "엄청떨렸어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "꿈속인건가",
            brideAnswer: "이제는현실"
        },
        {
            question : "결혼을 결심한 이유가 뭐야?",
            groomAnswer: "같이있을때",
            brideAnswer: "가장즐거워"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "밥은안굶겨",
            brideAnswer: "매일소고기"
        },
        {
            question : "마지막으로 서로에게 하고 싶은 말은?",
            groomAnswer: "잘살아봅세",
            brideAnswer: "나랑평생해"
        }
    ]

    const informationList =[
        {
            title : "♥신랑신부가 준비한 포토부스 이벤트♥",
            content : "10시30분-12시 운영합니다! \n많이 참여해주세요\n\n예쁜사진과 축하메시지를 남겨주시고,\n인생사진도 마음껏 가져가세요 :D"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ff8faf"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.brideNameEn)} brideNameEn={toUpperCaseString(weddingData.groomNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <MotionWrapper initialY={50}>
                            {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                            <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forShuttleBus={forShuttleBus} forSubway={forSubway} forBus={forBus} forCar={forCar} conceptStyle={conceptStyle}/>
                    {/* <Information titleFontSize={"15px"} pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default SeoHyeRim;